import * as React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';
export default () => (
    <Card sx={{m: 5}}>
        <Title title="Wapy Admin" />
        <CardContent>Bienvenue sur le tableau de bord de Wapy !</CardContent>
    </Card>
);